module.exports = __webpack_public_path__ + "img/img-sportsbook-d.b4b5fe99.png";